import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  const divisions = [
    {
      id: "solar",
      title: "ATR SOLAR",
      subtitle: "The Engineering Powerhouse",
      desc: "Specializing in Industrial Solar Greenhouse Dryers with IoT remote monitoring. We turn Madurai's sunlight into industrial heat.",
      img: "https://atrmart.in/images/solar-dryer-main.jpg", 
      features: ["Remote Monitoring", "Industrial Efficiency", "IoT Integrated"]
    },
    {
      id: "agro-foods",
      title: "ATR AGRO FOODS",
      subtitle: "Purity in Every Gram",
      desc: "Premium processed foods including Moringa and Spices, dried in our own solar facilities to ensure 100% nutrient retention.",
      img: "https://atrmart.in/images/moringa-processing.jpg", // Replace with your real image
      features: ["Hygienic Processing", "No Chemicals", "Export Quality"]
    },
    {
      id: "mart",
      title: "ATR MART",
      subtitle: "The Digital Nervous System",
      desc: "The central management hub connecting our R&D, Factory, and Admin departments for seamless operations.",
      img: "https://atrmart.in/images/digital-infrastructure.jpg", // Replace with your real image
      features: ["Centralized Admin", "R&D Focused", "Data Security"]
    },
    {
      id: "agro-mart",
      title: "ATR AGRO MART",
      subtitle: "The Farmers' Global Gateway",
      desc: "A revolutionary marketplace connecting South Indian farmers with global buyers and quality agricultural inputs.",
      img: "https://atrmart.in/images/agro-marketplace.jpg", // Replace with your real image
      features: ["Seller Portal", "Direct Sourcing", "Agro Community"]
    }
  ];

  return (
    <div className="super-ui-wrapper">
      <section className="about-hero">
        <div className="hero-overlay">
          <h1>Building the Future of Agriculture</h1>
          <p>Innovation. Sustainability. Community.</p>
        </div>
      </section>

      {divisions.map((item, index) => (
        <section className={`division-row ${index % 2 === 1 ? 'reverse' : ''}`} key={item.id}>
          <div className="division-image">
            <img src={item.img} alt={item.title} />
          </div>
          <div className="division-text">
            <span className="subtitle">{item.subtitle}</span>
            <h2>{item.title}</h2>
            <p>{item.desc}</p>
            <div className="feature-tags">
              {item.features.map(f => <span key={f} className="tag">{f}</span>)}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default AboutPage;